import {Component, Input, OnInit} from '@angular/core';
import * as Highcharts from 'highcharts/highstock';

declare var require: any;
const Boost = require('highcharts/modules/boost');
const noData = require('highcharts/modules/no-data-to-display');
const More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);

@Component({
  selector: 'app-chart-page',
  templateUrl: './chart-page.component.html',
  styleUrls: ['./chart-page.component.scss']
})
export class ChartPageComponent implements OnInit {

  @Input() chartData: any;
  @Input() indexID = 'iboxx';
  @Input() chartType = 'single';
  @Input() timePeriod: any;

  chart: Highcharts.Chart | undefined;
  chartColors: string[] = ['#00B5F1', '#00AB4E', '#96157C', '#009697', '#7ECB19', '#FA931C'];
  redDotChartPic: any = 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTM0A1t6AAAAx0lEQVQoU5WQTQrCMBSEU1sxKp5FLcWLiFa9mQuvoHt30oWIoDs3Yls1br2BP/NiUl4hXTjwMembCUkjuJ7dYc0sC2Hmm2VZCBppfzyHH8HBuMJsAw9M7ScMpOqN7vCPC2RXuLRlPwvjBS+4SMOYTu3oewP6cBYZCnj2lD0LqshAsWHHgiou4K8NKfCo7OXRdMUCF290EnjLntC8RZMHK3BeyE7wti5bYSDzwWwNp5Be7Qy2mC0pM7WyEARA/xg5oCev61BLiC/jA/NSAYFriAAAAABJRU5ErkJggg==)';
  greenDotChartPic: any = 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTM0A1t6AAAAy0lEQVQoU32SQQrCMBBFq6n2dqFo76ZbF5JCBMGd4A0UF+pCxIWKtxBa37RTqRo68Phk8jOZSRt9hbcD6OtK1r2KYIh5PlqhW3CwhD25BWrUpeFtHLl0h5ZBXPpAh43ZUGWCvj6Gfwo8U5R25aS3UiFkbHOFuG7H27Mmu5CizFIfOGqyC/HwYt4mcNJkFxeoZjCxy3K00I0QhXHZDNXn5RaTj6VCyFyy90ST2twEswzybIPe4ADyXe7k1rKnrp+QHutHEBXkV2mZo+gN+sbE3CvSQWkAAAAASUVORK5CYII=)';
  options: any = {
    chart: {
      type: 'line',
      height: '400px',
      animation: false,
      events: {
        load(): any {
          const chartAreas = document.getElementsByClassName('chart-area');
          setTimeout(() => {
            if (chartAreas[chartAreas.length - 1] !== undefined) {
              if (chartAreas[chartAreas.length - 1].clientWidth > 100) {
                // @ts-ignore
                this.setSize();
              } else {
                // @ts-ignore
                this.setSize(chartAreas[chartAreas.length - 1].clientWidth);
              }
            }
          }, 1);
        },
      }
    },
    legend: {
      enabled: true,
      align: 'left',
      verticalAlign: 'top',
      itemStyle: {
        fontSize: '11px',
      }
    },
    title: {
      text: undefined
    },
    credits: {
      enabled: false
    },
    tooltip: {
      valueDecimals: 4,
      enabled: true,
      useHTML: true,
      xDateFormat: '%A %e %B %Y',
      crosshairs: true,
      shared: true,
      split: false,
      style: {
        zIndex: 1000,
        opacity: 1
      },
      headerFormat: '<table style=" height: 100%; width: 100%; border-color: {point.color}; background-color: #f7f7f7;column-span: 2"><tr><td style="font-size: 10px" class="tooltip-span">{point.key}</td></tr>',
      pointFormat: '<tr><td style="color:{point.color}">\u25CF {series.name}:</td><td> <b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      // @ts-ignore
      formatter(): any {
        let result = '<div style="background: #f7f7f7; font-size: 10px; width: 100%; height: 50%">' +
          // @ts-ignore
          Highcharts.dateFormat('%A %e %B %Y', this.points[0].key) + '</div>';
        // @ts-ignore
        for (const point of this.points) {
          result += '<div style="background: #f7f7f7; width: 100%; height: 50%"><span style="color:' + point.color + '">\u25CF ' +
            point.series.name + ' </span>: <b>' + point.y + '</b>';
          if (point.point.change || point.point.change === 0){
            result += '(' + point.point.change.toFixed(4) + ' %) </div>';
          }else{
            result += '</div>';
          }
        }
        return result;
      },
    },
    xAxis: {
      ordinal: true,
      useHTML: true,
      labels: {
        align: 'left',
        step: 1,
        enabled: true,
        style: {
          'font-family': 'Source Sans Pro',
          width: 180
        },
      },
    },
    yAxis: {
      allowDecimals: true,
      labels: {
        x: 20,
        enabled: true
      },
      title: {
        text: ''
      },
      opposite: true
    },
    series: [],
    lang: {
      noData: 'No Data to display'
    },
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
      }]
    },
    plotOptions: {
      series: {
        turboThreshold: 0,
        boostThreshold: 10000,
        states: {
          hover: {
            lineWidthPlus: 5
          }
        },
        dataGrouping: {
          enabled: false,
        },
      },
      line: {
        animation: false,
        lineWidth: 2,
        marker: {
          enabled: false,
          enabledThreshold: 100,
          radius: 0,
          animation: {
            duration: 400
          }
        },
        dataLabels: {
          enabled: false,
          useHTML: true,
          reserveSpace: true,
          inside: false,
          crop: false,
          overflow: 'justify',
          backgroundColor: 'green'
        }
      },
    },
  };
  tickPosition: number[] = [];
  tickPositionToDisplay: number[] = [];
  dateValue: number[] = [];

  constructor() {
  }

  ngOnInit(): void {
    switch (this.chartType) {
      case 'single':
        if (this.chartData) {
          this.createChart(this.chartData);
        }
        break;
      case 'multi':
        this.updateChart(this.chartData);
        break;
    }
  }

  createChart(dataSource: any): void {
    let updatedData = null;
    if (dataSource.chartSeries.data) {
      updatedData = this.getChartOptions(dataSource, this.chartColors[this.options.series.length].substring(1));
    }
    this.addSeries(this.chartData.chartSeries.name, updatedData);
    this.updateTicker();
    this.renderChart();
  }

  updateChart(dataSources: any): void{
    for (const dataSource of dataSources) {
      let updatedData = null;
      if (dataSource.chartSeries.data) {
        updatedData = this.getChartOptions(dataSource, this.chartColors[this.options.series.length].substring(1));
      }
      this.addSeries(dataSource.chartSeries.name, updatedData);
    }
    this.updateTicker();
    this.renderChart();
  }

  updateTicker(): void{
    // tslint:disable-next-line:typedef
    this.options.xAxis.tickPositioner = function() {
      const newDayChartTicks = [];
      const ticks: any[] = [];
      if (this.series) {
        const dates = [];
        for (const chartSeries of this.series) {
          if (chartSeries.xData && chartSeries.visible) {
            for (const tick of chartSeries.xData) {
              dates.push(tick);
            }
          }
        }
        const distinctDates = dates.filter(function onlyUnique(value, index, self): any {
          return self.indexOf(value) === index;
        });
        distinctDates.sort((a, b) => a > b ? 1 : -1);
        let currentDate = null;
        for (const dateTicks of distinctDates) {
          if (currentDate === null
            || currentDate.getFullYear() !== new Date(dateTicks).getFullYear()
            || currentDate.getMonth() !== new Date(dateTicks).getMonth()
            || currentDate.getDate() !== new Date(dateTicks).getDate()) {
            currentDate = new Date(dateTicks);
            newDayChartTicks.push(dateTicks);
          }
        }
        if (distinctDates.length > 0 && newDayChartTicks.length > 0) {
          const startTick = newDayChartTicks[0];
          const endTick = newDayChartTicks[newDayChartTicks.length - 1];
          const widthPerTick = this.width / (endTick - startTick);
          let x1: any = null;
          let x2: any = null;
          newDayChartTicks.forEach((dateTick, index) => {
            x2 = index === newDayChartTicks.length - 1 ? endTick : (dateTick - startTick) * widthPerTick;
            if (index === 0 || ((x2 - x1) > 43) && (x2 === endTick || (endTick - x2) > 43)) {
              x1 = x2;
              ticks.push(dateTick);
            }
          });
        }
      }
      return ticks;
    };
  }

  addSeries(chartName: string, chartData: any): void {
    const series = {
      name: chartName,
      data: chartData,
      turboThreshold: 0,
      boostThreshold: 10000,
      color: this.chartColors[this.options.series.length],
      marker: {
        enabled: true,
        states: {
          hover: {
            enabled: true
          }
        }
      },
    };
    const actualTimePeriod = this.timePeriod;
    if (chartData.length > 0) {
      if ((this.timePeriod === 'No period selected' || this.timePeriod === 'custom'
        || this.timePeriod === 'ALL' || this.timePeriod === 'YTD')) {
        // @ts-ignore
        const days = chartData.length > 0 ? (new Date(chartData[chartData.length - 1].x) - new Date(chartData[0].x)) / (1000 * 60 * 60 * 24)
          : 0;
        if (days <= 7) {
          this.timePeriod = '1W';
        } else if (days <= 30) {
          this.timePeriod = '1M';
        } else if (days <= 90) {
          this.timePeriod = '3M';
        } else if (days <= 180) {
          this.timePeriod = '6M';
        } else if (days <= 365) {
          this.timePeriod = '1Y';
        } else if (days <= 1095) {
          this.timePeriod = '3Y';
        } else if (days <= 1825) {
          this.timePeriod = '5Y';
        } else {
          this.timePeriod = '10Y';
        }
      }
    }
    this.setTickPosition(this.dateValue, actualTimePeriod);
    if (this.timePeriod === '1W') {
      this.options.xAxis.tickPositions = this.tickPositionToDisplay;
      this.options.xAxis.labels.formatter = function(): any {
        let firstPoint = false;
        this.axis.tickPositions.forEach((value: any, index: number) => {
          if (this.value === value && index === 0) {
            firstPoint = true;
          }
        });
        return Highcharts.dateFormat(firstPoint ? '<span">%a<br/>%e-%b-%Y</span>' : '%a', this.value);
      };
    }
    if (this.timePeriod === '1M' || this.timePeriod === '3M') {
      const firstDays: any[] = [];
      let year = 0;
      const months: any = [];
      const monthsOnly: any[] = [];
      this.options.xAxis.tickPositions = this.tickPosition;
      this.tickPosition.forEach((value: any, index: number) => {
        if (index === 0) {
          year = new Date(value).getFullYear();
          firstDays.push(value);
          months.push(new Date(value).getMonth());
        } else {
          if (new Date(value).getFullYear() === year) {
            const month = new Date(value).getMonth();
            if (!months.includes(month)) {
              months.push(month);
              monthsOnly.push(value);
            }
          } else {
            firstDays.push(value);
            months.push(new Date(value).getMonth());
            year = new Date(value).getFullYear();
          }
        }
        this.tickPositionToDisplay.push(value);
      });
      this.options.xAxis.tickPositions = this.tickPositionToDisplay;
      this.options.xAxis.labels.formatter = function(): any {
        let pointToFull = false;
        let showMonthsOnly = false;
        this.axis.tickPositions.forEach(() => {
          pointToFull = firstDays.includes(this.value);
          showMonthsOnly = monthsOnly.includes(this.value);
        });
        return Highcharts.dateFormat(pointToFull ? '<span>%e<br/>%b-%Y</span>' :
          showMonthsOnly ? '<span>%e<br/>%b</span>' : '%e', this.value);
      };
      if (this.timePeriod === '3M') {
        this.options.xAxis.ordinal = true;
      }
    }
    if (this.timePeriod === '6M' || this.timePeriod === '1Y' || this.timePeriod === '3Y') {
      const years: any[] = [];
      const dateToShowMonthYear: any = [];
      const dateToShowMnthYr: any[] = [];
      const dateToShowMnthOnly: any = [];
      let pointToFull = false;
      let pointsToShowMnthOnly = false;
      let previousVal = 0;
      this.tickPosition.forEach((value: any, index: number) => {
        if (index === 0) {
          pointToFull = true;
          years.push(new Date(value).getFullYear());
          dateToShowMonthYear.push(value);
          this.tickPositionToDisplay.push(value);
        }
        if (index === this.tickPosition.length - 1 && this.timePeriod === '3Y') {
          if (new Date(previousVal).getMonth() === new Date(value).getMonth()) {
            dateToShowMnthOnly.push(previousVal);
            this.tickPositionToDisplay.push(previousVal);
          } else {
            dateToShowMnthOnly.push(value);
            this.tickPositionToDisplay.push(value);
          }
        }
        const month = new Date(value).getMonth();
        const year = new Date(value).getFullYear();
        if (month === 0) {
          if (!years.includes(year)) {
            years.push(year);
            if (this.timePeriod !== '3Y') {
              dateToShowMonthYear.push(value);
            }
            this.tickPositionToDisplay.push(value);
            dateToShowMnthYr.push(month + '#' + year);
          }
        }
        if (!dateToShowMnthYr.includes(month + '#' + year)) {
          dateToShowMnthYr.push(month + '#' + year);
          if (this.timePeriod !== '3Y') {
            this.tickPositionToDisplay.push(value);
          } else {
            previousVal = value;
            if ((month) % 3 === 0) {
              dateToShowMnthOnly.push(value);
              this.tickPositionToDisplay.push(value);
            }
          }
        }
      });
      this.options.xAxis.tickPositions = this.tickPositionToDisplay;
      if (this.timePeriod !== '3Y') {
        this.options.xAxis.labels.formatter = function(): any {
          this.axis.tickPositions.forEach(() => {
            pointToFull = dateToShowMonthYear.includes(this.value);
          });
          return Highcharts.dateFormat(pointToFull ? '%b<br/>%Y' : '%b', this.value);
        };
      } else {
        this.options.xAxis.tickPositions = this.tickPositionToDisplay;
        this.options.xAxis.labels.formatter = function(): any {
          this.axis.tickPositions.forEach(() => {
            pointToFull = dateToShowMonthYear.includes(this.value);
            pointsToShowMnthOnly = dateToShowMnthOnly.includes(this.value);
          });
          return Highcharts.dateFormat(pointToFull ? '%b<br/>%Y' : (pointsToShowMnthOnly ? '%b' : '%b<br/>%Y'), this.value);
        };
      }
    }
    if (this.timePeriod === '5Y' || this.timePeriod === '10Y') {
      this.options.xAxis.ordinal = false;
      this.options.xAxis.labels.step = 0;
      const firstDates: any[] = [];
      this.tickPositionToDisplay = [];
      const uniqueYears: any[] = [];
      this.tickPosition.forEach((value: any) => {
        const year = new Date(value).getFullYear();
        if (!uniqueYears.includes(year)) {
          uniqueYears.push(year);
          firstDates.push(value);
          this.tickPositionToDisplay.push(value);
        }
      });
      this.options.xAxis.tickPositions = this.tickPositionToDisplay;
      this.options.xAxis.labels.formatter = function(): any {
        const pointToPlot = firstDates.includes(this.value);
        return Highcharts.dateFormat(pointToPlot ? '%Y' : '', this.value);
      };
    }
    // @ts-ignore
    this.options.series.push(series);
  }

  getChartOptions(dataSource: any, color: string): any {
    const historyData = this.manipulateChartData(dataSource.chartSeries);
    const max = Math.max.apply(Math, historyData.map((o: any) => {
      return o.y;
    }));
    const min = Math.min.apply(Math, historyData.map((o: any) => {
      return o.y;
    }));
    const rowNum = historyData.length;
    let maxFound = false;
    let minFound = false;
    const updatedData: any = [];
    historyData.map((a: any, index: number) => {
      const value: any = {};
      value.x = a.x;
      value.y = +a.y;
      value.marker = {};
      value.dataLabels = {};
      if (historyData.length > 1) {
        if (value.y === max) {
          if (!maxFound) {
            maxFound = true;
            value.marker.symbol = this.greenDotChartPic;
            value.dataLabels.className = 'chartMaxSeriesValue';
            value.dataLabels.enabled = true;
          } else {
            value.marker.symbol = 'none';
          }
        } else if (value.y === min) {
          if (!minFound) {
            minFound = true;
            value.marker.symbol = this.redDotChartPic;
            value.dataLabels.enabled = true;
            value.dataLabels.className = 'chartMinSeriesValue';
          } else {
            value.marker.symbol = 'none';
          }
        } else {
          value.marker.symbol = 'none';
          if (rowNum === (index + 1)) {
            value.dataLabels.enabled = true;
            value.dataLabels.y = 20;
            value.dataLabels.className = 'highlighted color-' + color;
          }
        }
      }
      updatedData.push(value);
    });
    return updatedData;
  }

  renderChart(): void {
    this.createChartDiv();
    this.chart = Highcharts.chart('chart-section-' + this.indexID, this.options);
  }

  createChartDiv(): void {
    const divElement = '<div id="chart-section-' + this.indexID + '"></div>';
    const chartAreas = document.getElementsByClassName('chart-area');
    chartAreas[chartAreas.length - 1].innerHTML = divElement;
  }

  manipulateChartData(historyData: any): any {
    const updatedData: any = [];
    historyData.data.map((a: any) => {
      const value: any = {};
      value.x = a.date;
      value.y = +a.value.toFixed(4, 4);
      this.dateValue.push(a.date);
      updatedData.push(value);
    });
    return updatedData;
  }
  setTickPosition(historyData: any, actualTimePeriod: string): void {
    this.tickPositionToDisplay = [];
    this.tickPosition = [];
    const tickValue: any[] = [];
    let lastDate: any;
    let firstDate: any;
    let firstMonth: any;
    let lastMonth: any;
    let lastYear: any;
    let year: any;
    let monthYear: any;
    if (this.timePeriod === '1W') {
      if (historyData.length > 0) {
        historyData.forEach((a: any, index: number) => {
          if (index === 0) {
            firstDate = new Date(a);
          }
          if (index === (historyData.length - 1)) {
            lastDate = new Date(a);
            firstDate.setDate(firstDate.getDate() + 7);
          }
          this.tickPositionToDisplay.push(a);
        });
      }
    } else if (this.timePeriod === '5Y' || this.timePeriod === '10Y') {
      historyData.forEach((a: any, index: number) => {
        if (index === 0) {
          firstMonth = new Date(a).getMonth();
          year = new Date(a).getFullYear();
          tickValue.push(a);
        } else {
          if (index <= 10 && year === new Date(a).getFullYear()) {
            tickValue.push(a);
            if (index === 10) {
              tickValue.forEach((ax: any, idx: number) => {
                if (idx === 0) {
                  this.tickPosition.push(ax);
                }
              });
            }
          } else {
            if (index < (historyData.length - 6)){
              this.tickPosition.push(a);
            } else if ((index >= historyData.length - 6) && lastYear === new Date(a).getFullYear()){
              this.tickPosition.push(a);
            }
            lastYear = new Date(a).getFullYear();
          }
        }
      });
    } else if (this.timePeriod === '6M' || this.timePeriod === '1Y') {
      historyData.forEach((a: any, index: number) => {
        if (index === 0){
          firstMonth = new Date(a).getMonth();
          if (actualTimePeriod !== 'YTD') {
            this.tickPosition.push(a);
          }
        }else{
          if (firstMonth !== new Date(a).getMonth()){
            firstMonth = new Date(a).getMonth();
            this.tickPosition.push(a);
          }
        }
      });
    } else if (this.timePeriod === '1M') {
      historyData.forEach((a: any, index: number) => {
        if (index === 0) {
          firstMonth = new Date(a).getMonth();
          tickValue.push(a);
        } else {
          if (index <= 3 && firstMonth === new Date(a).getMonth()) {
            tickValue.push(a);
            if (index === 3) {
              tickValue.forEach((ax: any) => {
                this.tickPosition.push(ax);
              });
            }
          } else {
            if ( index < historyData.length - 3) {
              this.tickPosition.push(a);
            } else if (index >= historyData.length - 3 && lastMonth === new Date(a).getMonth()) {
              this.tickPosition.push(a);
            }
            lastMonth = new Date(a).getMonth();
          }
        }
      });
    } else if (this.timePeriod === '3M') {
      const lastAddedDate = new Date(historyData[0]);
      lastAddedDate.setDate(lastAddedDate.getDate() + 7);
      historyData.forEach((a: any, index: number) => {
        if (index === 0){
          this.tickPosition.push(a);
        }else{
          if (new Date(a).getDay() === 1){
            this.tickPosition.push(a);
            lastAddedDate.setDate(new Date(a).getDate() + 7);
          }else{
            if (a >= lastAddedDate){
              this.tickPosition.push(a);
              lastAddedDate.setDate(new Date(a).getDate() + 7);
            }
          }
        }
      });
    } else if (this.timePeriod === '3Y') {
      historyData.forEach((a: any, index: number) => {
        firstMonth = new Date(a).getMonth();
        year  = new Date(a).getFullYear();
        if (index === 0){
          firstDate = a;
          monthYear = firstMonth + '' + year;
        } else if (index <= 5 && (monthYear === (firstMonth + '' + year))){
          if (index === 5) {
            this.tickPosition.push(firstDate);
          }
        } else {
          if (index < historyData.length - 5){
            this.tickPosition.push(a);
          } else if (index >= historyData.length - 5 && (monthYear === (firstMonth + '' + year))){
            this.tickPosition.push(a);
          }
          monthYear = firstMonth + '' + year;
        }
      });
    }
  }

  updateSeries(isRebased: boolean): void{
    if (isRebased) {
      this.options.tooltip.useHTML = true;
      this.options.tooltip.xDateFormat = '%A %e %B %Y';
      this.options.tooltip.valueDecimals = 4;
      this.options.tooltip.changeDecimals = 4;
      this.options.tooltip.crosshairs = true;
      this.options.tooltip.shared = true;
      this.options.tooltip.style.zIndex = 10000;
      this.options.plotOptions.series.compare = 'percent';
      this.options.plotOptions.series.showInNavigator = true;
      this.options.chart.defaultSeriesType = 'stockchart';
      this.options.series.forEach((element: any, index: number) => {
        const series = element;
        const points = series.data;
        points.forEach((point: any, pointIndex: number) => {
          if (point.dataLabels.className === 'chartMaxSeriesValue' || point.dataLabels.className === 'chartMinSeriesValue' ||
            (point.dataLabels.className && point.dataLabels.className.includes('highlighted'))) {
            point.dataLabels.enabled = false;
            point.marker.symbol = 'none';
            points[pointIndex] = point;
          }
        });
        series.data = points;
        this.options.series[index] = series;
      });
    } else {
      this.options.plotOptions.series.compare = 'none';
      this.options.plotOptions.series.showInNavigator = true;
      this.options.chart.defaultSeriesType = 'chart';
      this.showLabelsonChart(true);
    }
    this.renderChart();
  }

  showLabelsonChart(unRebase: boolean): void {
    this.options.series.forEach((element: any, index: number) => {
      const series = element;
      const points = series.data;
      points.forEach((point: any, pointIndex: number) => {
        if (point.dataLabels.className === 'chartMaxSeriesValue' || point.dataLabels.className === 'chartMinSeriesValue' ||
          (point.dataLabels.className && point.dataLabels.className.includes('highlighted'))) {
          if (unRebase) {
            point.dataLabels.enabled = true;
            if (point.dataLabels.className === 'chartMaxSeriesValue') {
              point.marker.symbol = this.greenDotChartPic;
            } else if (point.dataLabels.className === 'chartMinSeriesValue') {
              point.marker.symbol = this.redDotChartPic;
            }
          } else {
            point.dataLabels.enabled = false;
            point.marker.symbol = 'none';
          }
          points[pointIndex] = point;
        }
      });
      series.data = points;
      this.options.series[index] = series;
    });
  }
}
